import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import { CartProvider } from "@/contexts/CartContext";

// Remove Emergent badge injected by platform
function removeBadge() {
  const el = document.getElementById('emergent-badge');
  if (el) { el.parentNode.removeChild(el); }
  document.querySelectorAll('a[href*="emergent.sh"]').forEach(a => {
    if (a.textContent && a.textContent.includes('Emergent')) a.parentNode.removeChild(a);
  });
}
// Run immediately and observe for re-injection
removeBadge();
const badgeObserver = new MutationObserver(() => removeBadge());
if (document.body) {
  badgeObserver.observe(document.body, { childList: true, subtree: true });
}
window.addEventListener('load', () => {
  removeBadge();
  badgeObserver.observe(document.body, { childList: true, subtree: true });
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <CartProvider>
        <App />
      </CartProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
